import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import styled from 'styled-components';

import ChevronRight from '@tvg/fuse-icons/lib/ChevronRight';
import CheckboxGroup from 'client/pages/CheckboxGroup/CheckboxGroup';
import { BrandFacetGroup } from '../../CheckboxGroup/BrandFacetGroup/BrandFacetGroup';

const FuseDrawerStyled = styled.div`
  & .fuse-drawer .fuse-drawer__body {
    padding-top: var(--spacing-space24);
  }
`;
const CheckboxGroupStyled = styled(CheckboxGroup)`
  .fuse-checkbox__label:last-child {
    margin-bottom: 0;
  }

  & {
    text-align: left;
  }
`;

const BrandFacetGroupStyled = styled(BrandFacetGroup)`
  .fuse-checkbox__label:last-child {
    margin-bottom: 0;
  }
`;

const DivStyled = styled.div`
  margin-top: var(--spacing-space4);
`;

const DrawerButtonStyled = styled.button.attrs({
  className: 'fuse-accordion__button',
  'data-testid': 'fuse-accordion__button',
})`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  padding: var(--spacing-space24) 0;
  text-align: left;
  width: 100%;
  border-bottom: 1px solid var(--color-global-grey400);

  &:focus .fuse-accordion__heading,
  &:hover .fuse-accordion__heading {
    color: var(--color-brand-mid);
  }

  &:focus:after,
  &:hover:after {
    background: var(--color-brand-mid);
  }

  &:focus-visible,
  &:active {
    outline: var(--spacing-space2) solid var(--color-functional-focus);
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:after {
    content: '';
    display: inline-flex;
    flex: 0 0 var(--spacing-space24);
    height: var(--spacing-space24);
    mask: url('data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(<ChevronRight />))}') center/cover no-repeat;
    background: var(--color-base-black);
    margin-left: auto;
  }
`;

export { BrandFacetGroupStyled, CheckboxGroupStyled, DivStyled, DrawerButtonStyled, FuseDrawerStyled };
